import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { DangerSection, LifecycleSection } from '../components/settings/sections.js';
import { useRefreshBrand } from './brand.$slug.settings.js';

const parentRoute = getRouteApi('/brand/$slug/settings');

export const Route = createFileRoute('/brand/$slug/settings/danger')({
  component: DangerPage,
});

function DangerPage() {
  const { brand, brands } = parentRoute.useLoaderData();
  const refresh = useRefreshBrand();
  const liveBrands = brands.filter((b) => b.archivedAt === null);
  return (
    <>
      <LifecycleSection brand={brand} onChanged={refresh} />
      <DangerSection brand={brand} liveBrandCount={liveBrands.length} brands={liveBrands} />
    </>
  );
}
